import "./styles.css";

interface Props {
    label: string;
    fromValue: string | undefined;
    toValue: string | undefined;
    onFromChange: (val: string | undefined) => void;
    onToChange: (val: string | undefined) => void;
    type?: "number" | "date";
    fromPlaceholder?: string;
    toPlaceholder?: string;
}

export default function FilterRange({ label, fromValue, toValue, onFromChange, onToChange, type = "number", fromPlaceholder, toPlaceholder }: Props) {
    return (
        <div className="filter-range-wrap">
            <span className="filter-range-label">{label}</span>
            <div className="filter-range-box">
                <input
                    type={type}
                    className={`filter-range-input${type === "date" ? " filter-range-input--date" : ""}`}
                    value={fromValue ?? ""}
                    placeholder={fromPlaceholder}
                    onChange={(e) => onFromChange(e.target.value || undefined)}
                />
                <span className="filter-range-divider" />
                <input
                    type={type}
                    className={`filter-range-input${type === "date" ? " filter-range-input--date" : ""}`}
                    value={toValue ?? ""}
                    placeholder={toPlaceholder}
                    onChange={(e) => onToChange(e.target.value || undefined)}
                />
            </div>
        </div>
    );
}
